// Fixed words around a typed value (same rules as backend app/core/affix.py):
//   prefix "בן מו\"ה " + "מאיר" + suffix " הי\"ו"  ->  בן מו"ה מאיר הי"ו
//   prefix "{day} פרשת " + "נח" (Simcha Day = "יום ג'") ->  יום ג' פרשת נח
// Placeholders anywhere in a line: {day} = Simcha Day, {week} = Simcha Week (parsha), e.g. a fixed
// "בשב\"ק פרשת {week}" line on a Kiddush & Zucher card.
// The customer types only the value; the screen and the print show the whole line.
export const SIMCHA_DAY_FIELD_INPUT = '2f02c603-5a6d-45f8-9c0d-12cc065faa0f';
export const SIMCHA_WEEK_FIELD_INPUT = '0df22ddd-091e-4cf6-a6fc-4cb46c951cd4';
const IDS = { day: SIMCHA_DAY_FIELD_INPUT, week: SIMCHA_WEEK_FIELD_INPUT };
const LABELS = { day: 'simcha day', week: 'simcha week' };

const fieldText = (fields = [], which) => {
  const f = fields.find(
    (x) => x.field_input_id === IDS[which] || String(x.label || '').trim().toLowerCase() === LABELS[which]
  );
  return String(f?.text ?? f?.default_text ?? '').trim();
};

const fill = (s, fields) =>
  ['day', 'week'].reduce((out, which) => (out.includes(`{${which}}`) ? out.split(`{${which}}`).join(fieldText(fields, which)) : out), s);

export const displayText = (field, fields = []) => {
  const text = String(field?.text ?? '');
  const prefix = field?.prefix || '';
  const suffix = field?.suffix || '';
  if ((!prefix && !suffix) || !text.trim()) return text.includes('{') ? fill(text, fields) : text; // no orphan "בן מו"ה"
  return fill(`${prefix}${text}${suffix}`, fields).replace(/[ \t]+/g, ' ').trim();
};

export default displayText;
